import './stylesheets/App.css';
import Row from "./components/Row";
import FileUpload from "./components/FileUpload";
import Modal from "./components/Modal";
import { useState } from 'react';
import XLSX from 'xlsx-js-style';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

function App() {
  const [rows, setRows] = useState([{ id: 1, amount: '', start: '', end: '' }]);
  const [endDate, setEndDate] = useState('');
  const [total, setTotal] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [columnNames, setColumnNames] = useState({ amount: 'Capital', start: 'Fecha de inicio', end: 'Fecha de cierre', interest: 'Interés generado' });

  const addRow = () => {
    setRows([...rows, { id: rows.length + 1, amount: '', start: '', end: endDate }]);
  };

  const deleteRow = (id) => {
    if (rows.length > 1) {
      const updatedRows = rows.filter(row => row.id !== id);
      setRows(updatedRows);

      // Recalcular el total después de eliminar una fila
      let newTotal = 0;
      updatedRows.forEach(row => {
        const interest = parseFloat(document.getElementById(`payment-total-${row.id}`).value) || 0;
        newTotal += interest;
      });
      setTotal(parseFloat(newTotal.toFixed(2)));
    } else {
      alert('Debe haber al menos un Row.');
    }
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    const anyInvalidStart = rows.some(row => new Date(row.start) > new Date(newEndDate));
    if (anyInvalidStart) {
      alert('La fecha global de fin no puede ser anterior a ninguna fecha de inicio.');
    } else {
      setEndDate(newEndDate);
      setRows(rows.map(row => ({ ...row, end: newEndDate })));
    }
  };

  const handleInputChange = (id, field, value) => {
    if (field === 'start' && new Date(value) > new Date(endDate)) {
      alert('La fecha de inicio debe ser anterior a la fecha de fin.');
    } else {
      setRows(rows.map(row => (row.id === id ? { ...row, [field]: value } : row)));
    }
  };

  const calculateInterest = () => {
    let newTotal = 0;

    rows.forEach(row => {
      fetch(`${process.env.REACT_APP_SERVER_URL}/api/calculate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          amount: row.amount,
          startDate: row.start,
          endDate: row.end
        })
      })
          .then(response => response.json())
          .then(data => {
            const interest = data.interest;
            document.getElementById(`payment-total-${row.id}`).value = interest;
            newTotal += parseFloat(interest);
            setTotal(parseFloat(newTotal.toFixed(2)));
          })
          .catch(error => {
            console.error(error);
          });
    });
  };

  const handleFileUploaded = (data) => {
    console.log('Datos transformados antes de setRows:', data);
    const newRows = data.map((row, index) => ({
      id: index + 1,
      amount: row.amount,
      start: row.start,
      end: endDate // Usar la fecha de fin seleccionada en el frontend
    }));
    console.log('Filas nuevas:', newRows);
    setRows(newRows);
  };

  const handleSaveExcel = (names) => {
    setColumnNames(names);
    exportToExcel(names);
  };

  const handleSavePDF = (names) => {
    setColumnNames(names);
    exportToPDF(names);
  };

  const exportToExcel = (columnNames) => {
    const exportData = rows.map(row => ({
      [columnNames.amount]: row.amount,
      [columnNames.start]: row.start,
      [columnNames.end]: row.end,
      [columnNames.interest]: document.getElementById(`payment-total-${row.id}`).value
    }));

    // Añadir una fila con el total al final
    const totalRow = {
      [columnNames.amount]: '',
      [columnNames.start]: '',
      [columnNames.end]: '',
      [columnNames.interest]: `Total: ${total}`
    };

    exportData.push(totalRow);

    const worksheet = XLSX.utils.json_to_sheet(exportData, { header: [columnNames.amount, columnNames.start, columnNames.end, columnNames.interest] });

    // Establecer estilo en las cabeceras y la fila total
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    const headerStyle = {
      font: { bold: true }
    };

    for (let C = range.s.c; C <= range.e.c; ++C) {
      const headerAddress = XLSX.utils.encode_col(C) + "1";
      if (worksheet[headerAddress]) {
        worksheet[headerAddress].s = headerStyle;
      }
    }

    // Formatear la fila total
    const totalRowIndex = range.e.r + 1;
    const totalStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: "538DD5" } }
    };

    for (let C = range.s.c; C <= range.e.c; ++C) {
      const totalAddress = XLSX.utils.encode_col(C) + totalRowIndex;
      if (worksheet[totalAddress]) {
        worksheet[`D${totalRowIndex}`].s = totalStyle;
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Interests');
    XLSX.writeFile(workbook, 'Interests.xlsx');
  };

  const exportToPDF = (columnNames) => {
    const doc = new jsPDF();

    const tableData = rows.map(row => ({
      amount: row.amount,
      start: row.start,
      end: row.end,
      interest: document.getElementById(`payment-total-${row.id}`).value
    }));

    // Definir columnas de la tabla
    const tableColumns = [
      { title: columnNames.amount, dataKey: 'amount' },
      { title: columnNames.start, dataKey: 'start' },
      { title: columnNames.end, dataKey: 'end' },
      { title: columnNames.interest, dataKey: 'interest' }
    ];

    // Generar la tabla
    doc.autoTable({
      head: [tableColumns.map(col => col.title)],
      body: tableData.map(row => [
        row.amount,
        row.start,
        row.end,
        row.interest
      ]),
      startY: 20
    });

    // Agregar el total al final
    const finalY = doc.lastAutoTable.finalY || 20;
    doc.text(`Total del ${columnNames.interest}: ${total}`, 10, finalY + 10);

    // Guardar el PDF
    doc.save('Intereses.pdf');
  };


    return (
      <div className="App">
        <h1>Calcular Interés Anual</h1>
        <div className="calculator">
          <div className="global">
            <h3>Total: {total}</h3>
            <input type={'date'} id={'end-global'} value={endDate} onChange={handleEndDateChange} />
          </div>
          {rows.map(row => (
              <Row
                  key={row.id}
                  id={row.id}
                  amount={row.amount}
                  start={row.start}
                  end={row.end}
                  endDate={endDate}
                  onDelete={() => deleteRow(row.id)}
                  onInputChange={handleInputChange}
              />
          ))}
          <button className={'fullbutton'} onClick={addRow}>Agregar</button>
          <FileUpload onFileUploaded={handleFileUploaded} />
          <button className={'fullbutton action'} onClick={calculateInterest}>Calcular</button>
          <button className={'fullbutton'} onClick={() => setIsModalOpen(true)}>Descargar <i
              className="fa-solid fa-download"></i></button>
          <Modal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              onExcel={handleSaveExcel}
              onPDF={handleSavePDF}
          />
        </div>
        <footer>
        <p>© 2024 — <a href={'https://github.com/poisonrous'} target={'_blank'}>
          <strong>poisonrous</strong><i className='fab fa-github'></i>
        </a></p>
      </footer>
      </div>
  );
}

export default App;
